import { useMemo } from 'react';
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from '../../../../messages/en-US';
import { CauseCode } from './WorkOrdersTypes';

/**
 * Fixed Cause Code list (localized). `code` is the stable string key exchanged
 * with the backend (empty string = no cause code); `description` is the translated label.
 * TODO(backend): replace with a server-fed list once the endpoint exists.
 */
export function useCauseCodes(): CauseCode[] {
  const loc = useLocalization();

  const machineOutOfService = loc.toLanguageString(
    'custom.causeCodeMachineOutOfService',
    enMessages.custom.causeCodeMachineOutOfService
  );
  const greasedManually = loc.toLanguageString(
    'custom.causeCodeGreasedManually',
    enMessages.custom.causeCodeGreasedManually
  );
  const rfidTagUnscannable = loc.toLanguageString(
    'custom.causeCodeRfidTagUnscannable',
    enMessages.custom.causeCodeRfidTagUnscannable
  );
  const greaseVolume = loc.toLanguageString(
    'custom.causeCodeGreaseVolume',
    enMessages.custom.causeCodeGreaseVolume
  );

  return useMemo<CauseCode[]>(
    () => [
      { code: 'MS-C1', description: machineOutOfService },
      { code: 'MS-C2', description: greasedManually },
      { code: 'MS-C3', description: rfidTagUnscannable },
      { code: 'MS-C4', description: greaseVolume },
    ],
    [machineOutOfService, greasedManually, rfidTagUnscannable, greaseVolume]
  );
}
